export const COVER_RATIO = 512 / 772;
export const HERO_RATIO = 16 / 9;

/** Fit the preview beneath the global header, retaining the source card's media ratio. */
export function distributionPreviewBounds(
	anchor: { left: number; top: number; width: number; height: number },
	viewport: { width: number; height: number },
	ratio = COVER_RATIO,
) {
	const gutter = 12;
	const topInset = 64;
	const availableHeight = Math.max(1, viewport.height - topInset - gutter);
	// A continuous size curve avoids the old 190px breakpoint and the 200px
	// minimum, which could more than double a small mosaic tile on hover.
	const scale = ratio === HERO_RATIO ? 1.1 : 1.15 + .25 * Math.max(0, Math.min(1, (240 - anchor.width) / 120));
	const width = Math.max(1, Math.min(
		anchor.width * scale,
		viewport.width - gutter * 2,
		availableHeight * ratio,
	));
	const height = width / ratio;
	const left = Math.max(gutter, Math.min(
		anchor.left + (anchor.width - width) / 2,
		viewport.width - width - gutter,
	));
	const top = Math.max(topInset, Math.min(
		anchor.top - (height - anchor.height) / 2,
		viewport.height - height - gutter,
	));
	return { left, top, width };
}
